// Modules
import { gql } from '@apollo/client'

export const CreateBiometryUrl = gql`
    mutation createBiometryUrl($federalTaxId: String!, $callbackUri: String!) {
        createBiometryUrl(federalTaxId: $federalTaxId, callbackUri: $callbackUri) {
            id
            userRedirectUrl
        }
    }
`

export const UPDATE_CONTACT_BIOMETRY_MUTATION = gql`
    mutation updateContactBiometry($federalTaxId: String!, $unicoId: String!) {
        updateContactBiometry(federalTaxId: $federalTaxId, unicoId: $unicoId) {
            mdmContactId
        }
    }
`

export const CREATE_DRAFT_FACIAL_BIOMETRY_COMTACTS = gql`
    mutation createDraftFacialBiometryContacts($newContacts: [MDMPatientContactInput!]!, $uniqueId: String!) {
        createDraftFacialBiometryContacts(newContacts: $newContacts, uniqueId: $uniqueId) {
            status
        }
    }
`

export const AUTH_BIOMETRY_MUTATION = gql`
    mutation authBiometry($federalTaxId: String!, $unicoId: String!, $logInfo: LogInfoInput!) {
        authBiometry(federalTaxId: $federalTaxId, unicoId: $unicoId, logInfo: $logInfo) {
            access_token
            refresh_token
        }
    }
`

export const CHANGE_PASSWORD_UNICO_MUTATION = gql`
    mutation changePasswordUnico($username: String!, $newPassword: String!, $unicoId: String!) {
        changePasswordUnico(username: $username, newPassword: $newPassword, unicoId: $unicoId) {
            message
        }
    }
`
